import React from 'react'
import LargePlayer from './LargePlayer'
import LargePlayingCard from '../PlayingCards/LargePlayingCard'
import { REVEAL, PLACE } from '../queries'
import { usePlayGameContext } from '../playGameContext'
import { useMutation } from '@apollo/react-hooks'
import { roundCardScores } from '../PlayingCards/cardHelpers'

/**
 * Displays a Big Player with their cards and actions to play cards
 */
const PlayGamePlayer = ({ player }) => {
  const visibleCards = player?.visibleCards ?? new Array(4).fill(null)
  const actions = player?.actions ?? []

  // Show card scores if all 4 cards are played
  const showCardScores =
    visibleCards.filter((itm) => Number.isInteger(itm)).length === 4
  const scores = showCardScores
    ? roundCardScores(visibleCards)
    : new Array(4).fill()

  return (
    <LargePlayer player={player}>
      {visibleCards.map((cardId, spotIndex) => {
        if (Number.isInteger(cardId))
          return (
            <LargePlayingCard
              key={spotIndex}
              id={cardId}
              score={scores[spotIndex]}
            />
          )
        if (actions.includes('reveal') || actions.includes('place'))
          return (
            <ClickableCard
              key={spotIndex}
              spotIndex={spotIndex}
              actions={actions}
            />
          )
        return <LargePlayingCard key={spotIndex} spotIndex={spotIndex} />
      })}
    </LargePlayer>
  )
}

const ClickableCard = ({ actions, spotIndex }) => {
  const playGameContext = usePlayGameContext()
  const id = playGameContext?.game?.id
  const variables = { game: id, spot: spotIndex }

  const mutation = actions.includes('reveal') ? REVEAL : PLACE
  const [runMutation, { loading }] = useMutation(mutation, { variables })

  if (loading) return <LargePlayingCard isLoading={loading} />

  return (
    <LargePlayingCard
      onClick={id ? () => runMutation() : undefined}
      label="Select this card to place here the card you just picked up. The card facing down will be discarded."
    />
  )
}

export default PlayGamePlayer
